import { User } from '@/model/data-object/User'
import useUserStatsFactory from '@/composables/user/userStatsFactory'
import { PubUser } from '@/model/data-object/PubUser'
import { UserInterface } from '@/model/data-object/UserInterface'

export default function useUserFactory() {
  const { createFromObject: createStatsFromObject } = useUserStatsFactory()

  const assignCommonProps = function(
    user: UserInterface,
    userProxy: UserInterface
  ) {
    user.id = userProxy.id
    user.nickname = userProxy.nickname
    user.profileLink = userProxy.profileLink
    user.blog = userProxy.blog
    user.isSubscriptionPremium = userProxy.isSubscriptionPremium
    user.isShowPremium = userProxy.isShowPremium
  }

  const createFromObject = function(userProxy: User): User {
    const user = new User()
    assignCommonProps(user, userProxy)
    user.email = userProxy.email
    user.isHideSubscribedUsers = userProxy.isHideSubscribedUsers
    user.isBanned = userProxy.isBanned
    user.isBanned = userProxy.isBanned
    user.isHideFollowers = userProxy.isHideFollowers
    user.isPayingCustomer = userProxy.isPayingCustomer
    user.stats = createStatsFromObject(userProxy.stats)
    user.activity.blockedUsersModifiedAt = new Date(
      userProxy.activity.blockedUsersModifiedAt
    )
    user.activity.lastActivityDate = new Date(
      userProxy.activity.lastActivityDate
    )
    user.activity.blockedUsersModifiedAt = new Date(
      userProxy.activity.blockedUsersModifiedAt
    )

    return user
  }

  const createPubFromObject = function(userProxy: PubUser): PubUser {
    const user = new PubUser()
    assignCommonProps(user, userProxy)

    return user
  }

  return { createFromObject, createPubFromObject }
}
